import { useCallback, useEffect, useRef } from "react"

// Escape belongs to the topmost layer only. Sheets stack on top of Settings
// (and confirmations on top of sheets) as sibling portals, so DOM order and
// focus cannot say which one is on top; this mount-ordered stack can.
const layers: symbol[] = []

export function useModalLayer(): () => boolean {
    const id = useRef(Symbol("modal-layer"))
    useEffect(() => {
        const current = id.current
        layers.push(current)
        return () => {
            const index = layers.indexOf(current)
            if (index >= 0) layers.splice(index, 1)
        }
    }, [])
    return useCallback(() => layers[layers.length - 1] === id.current, [])
}
